import React from 'react';
import './Button.css';

function Button({ children, onClick, type = 'button', style = {} }) {
  return (
    <button className="custom-button" type={type} onClick={onClick} style={style}>
      {children}
    </button>
  );
}

export default Button;
